import {
  ADFORM_PREBID_BIDDER,
  RTBHOUSE_PREBID_BIDDER,
  YANDEX_PREBID_BIDDER,
  INDEX_EXCHANGE_BIDDER,
  PUBMATIC_PREBID_BIDDER,
  THEADX_PREBID_BIDDER,
  ADMATIC_PREBID_BIDDER,
  ESKIMI_PREBID_BIDDER,
  ONEFIFTYTWOMEDIA_PREBID_BIDDER,
  TEADS_PREBID_BIDDER,
} from '../bidders';

export const commonAdUnits = {
  desktop: {
    masthead: {
      name: 'masthead',
      sizes: [[1100, 250], [980, 250], [970, 250], [940, 250], [728, 90], [1100, 1], 'fluid'],
      divId: 'masthead',
      isProject: true,
      refreshTimer: 180,
      cls: 'max',
      collapse: false,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1010076),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042155),
          PUBMATIC_PREBID_BIDDER(5508960),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'onedio.co_desktop_masthead',
          sizes: [[1100, 250], [1100, 130], [980, 250], [970, 90], [970, 250], [728, 90], 'fluid'],
        },
      },
    },
    datacollect: {
      name: 'Onedio.com_Data_Collect',
      sizes: [[1, 1]],
    },
    // interstitial: {
    //   name: 'Onedio.com_Desktop_Prestitial',
    //   sizes: [[1, 1]],
    //   divId: 'prestital',
    //   hideLoading: true,
    //   isOutOfPage: true,
    //   referrer: {
    //     include: ['onedio.com', 'localhost'],
    //     exclude: ['onedio.com/instagram'],
    //   },
    // },
    pageskinLeft: {
      name: 'Onedio.com_Desktop_Pageskin_Genel_Left',
      sizes: [
        [160, 600],
        [120, 600],
        [140, 600],
      ],
      divId: 'pageskinLeft',
      cls: 'max',
      hideLoading: true,
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Skyscraper_Left',
          sizes: [
            [160, 600],
            [120, 600],
            [140, 600],
          ],
        },
      },
    },
    pageskinRight: {
      name: 'Onedio.com_Desktop_Pageskin_Genel_Right',
      sizes: [
        [160, 600],
        [120, 600],
        [140, 600],
      ],
      divId: 'pageskinRight',
      cls: 'max',
      hideLoading: true,
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Skyscraper_Right',
          sizes: [
            [160, 600],
            [120, 600],
            [140, 600],
          ],
        },
      },
    },
    vitrin: {
      name: 'Onedio.com_Desktop_Project_Vitrin',
      sizes: [[1, 1]],
      divId: 'vitrinProject',
      hideLoading: true,
    },
    megamenuAd: {
      name: 'Onedio.com_Desktop_MegaMenu',
      sizes: [[266, 85]],
      hideLoading: true,
      cls: 'none',
      collapse: false,
    },
    customIntersitial: {
      name: 'Onedio.com_Desktop_Prestitial',
      sizes: [
        [970, 250],
        [980, 250],
        [1100, 300],
        [980, 300],
        [800, 600],
        [1100, 130],
        [336, 280],
        [970, 90],
        [1, 1],
        [970, 300],
        [300, 600],
        [1100, 250],
        [320, 480],
        [970, 130],
        [300, 250],
        [250, 250],
        'fluid',
      ],
      hideLoading: true,
      referrer: {
        include: ['onedio.com', 'localhost', '127.0.0.1'],
      },
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(2077376),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042155),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
    },
    redirect: {
      name: 'Onedio.com_Desktop_Redirect',
      sizes: [[250, 250], [336, 280], [300, 250], [480, 320], [200, 200], [320, 480], [580, 400], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666467),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
    },
  },
  mobile: {
    masthead: {
      name: 'Mobile_masthead',
      // Sticky Temp Remove
      sizes: [[300, 100], [320, 100], [320, 50], 'fluid'],
      // sizes: [[300, 100], [300, 150], [300, 250], [320, 100], [320, 150], [320, 50], 'fluid'],
      divId: 'div-gpt-ad-1439154978422-0',
      isProject: true,
      refreshTimer: 8,
      cls: 'max',
      collapse: false,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1012352),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042151),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'onedio.co_mobile_masthead',
          sizes: [[300, 150], 'fluid', [320, 50], [320, 100], [320, 150], [300, 100]],
        },
      },
    },
    InstagramMasthead: {
      name: 'Onedio.com_Mobile_InstagramBridge_Header',
      sizes: [[300, 50], [320, 50], [300, 100], [320, 100], 'fluid'],
      collapse: false,
      prebid: {
        bids: [
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042151),
          PUBMATIC_PREBID_BIDDER(5508964),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
    },
    datacollect: {
      name: 'Onedio.com_Data_Collect',
      sizes: [[1, 1]],
    },
    // interstitial: {
    //   name: 'Mobile_Prestital',
    //   sizes: [[1, 1]],
    //   divId: 'prestital',
    //   hideLoading: true,
    //   isOutOfPage: true,
    //   referrer: {
    //     include: ['onedio.com', 'localhost'],
    //     exclude: ['onedio.com/instagram'],
    //   },
    // },
    vitrin: {
      name: 'Onedio.com_Mobile_Project_Vitrin',
      sizes: [[1, 1]],
      divId: 'vitrinProject',
      hideLoading: true,
    },
    stickyFooter: {
      name: 'Onedio.com_Mobile_Footer_Sticky',
      sizes: [[300, 50], [320, 50], [300, 100], [320, 100], 'fluid'],
      divId: 'div-gpt-ad-sticky',
      refreshTimer: 30,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1651167),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042154),
          PUBMATIC_PREBID_BIDDER(5508964),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Footer_Sticky',
          sizes: [[300, 50], [300, 100], 'fluid', [320, 50], [320, 100], [320, 150]],
        },
      },
    },
    megamenuAd: {
      name: 'Onedio.com_Mobile_MegaMenu',
      sizes: [[266, 85]],
      hideLoading: true,
      cls: 'none',
    },
    customIntersitial: {
      name: 'Mobile_Prestital',
      sizes: ['fluid', [1, 1], [300, 250], [320, 480], [250, 250], [336, 280]],
      hideLoading: true,
      referrer: {
        include: ['onedio.com', 'localhost', '127.0.0.1'],
      },
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(2077510),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(759),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
    },
    redirect: {
      name: 'Onedio.com_Mobile_Redirect',
      sizes: [[300, 75], 'fluid', [250, 250], [300, 250], [200, 200], [300, 150], [300, 100], [300, 50], [320, 100], [320, 50]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          PUBMATIC_PREBID_BIDDER(5508966),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
    },
  },
};
